import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';

import { InfoPanel } from '@/contexts/infoPanel/components/InfoPanel.comp.tsx';
import { InfoPanelContextProvider } from '@/contexts/infoPanel/InfoPanel.context.tsx';
import { InfoKey } from '@/contexts/infoPanel/model/InfoKey.enum.ts';

export const InfoPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [currentInfoKey, setCurrentInfoKey] = useState<InfoKey | null>(null);

  const openPanel = useCallback((key: InfoKey) => {
    setCurrentInfoKey(key);
  }, []);

  const closePanel = useCallback(() => {
    setCurrentInfoKey(null);
  }, []);

  const contextValue = useMemo(
    () => ({
      closePanel,
      currentInfoKey,
      isOpen: currentInfoKey !== null,
      openPanel,
    }),
    [closePanel, currentInfoKey, openPanel],
  );

  return (
    <InfoPanelContextProvider value={contextValue}>
      {children}
      <InfoPanel infoKey={currentInfoKey} isOpen={currentInfoKey !== null} onClose={closePanel} />
    </InfoPanelContextProvider>
  );
};
